export default __webpack_public_path__ + "static/media/profileImg.514cdca0.jpg";